import type { inferQueryKeys } from '@lukemorales/query-key-factory';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAccount } from '../apiClient';

export const accountsQueries = createQueryKeys('accounts', {
  detail: () => ({
    queryKey: ['/accounts'],
    queryFn: () => getAccount(),
  }),
});

export type AccountsQueries = inferQueryKeys<typeof accountsQueries>;
